// src/components/slack-connect-button/DefaultSlackConnectButton.tsx
import { useMemo } from "react";
import { Mounter } from "../Mounter.js";
import { jsx } from "react/jsx-runtime";
var DefaultSlackConnectButton = (props) => {
  const {
    integrationIdentifier,
    connectionIdentifier,
    subscriberId,
    context,
    contextHash,
    scope,
    connectionMode,
    autoLinkUser,
    onConnectSuccess,
    onConnectError,
    onDisconnectSuccess,
    onDisconnectError,
    connectLabel,
    connectedLabel
  } = props;
  const mountProps = useMemo(
    () => ({
      integrationIdentifier,
      connectionIdentifier,
      subscriberId,
      context,
      contextHash,
      scope,
      connectionMode,
      autoLinkUser,
      onConnectSuccess,
      onConnectError,
      onDisconnectSuccess,
      onDisconnectError,
      connectLabel,
      connectedLabel
    }),
    [
      integrationIdentifier,
      connectionIdentifier,
      subscriberId,
      context,
      contextHash,
      scope,
      connectionMode,
      autoLinkUser,
      onConnectSuccess,
      onConnectError,
      onDisconnectSuccess,
      onDisconnectError,
      connectLabel,
      connectedLabel
    ]
  );
  return /* @__PURE__ */ jsx(Mounter, { name: "SlackConnectButton", props: mountProps });
};
export {
  DefaultSlackConnectButton
};
//# sourceMappingURL=DefaultSlackConnectButton.js.map